import { useCallback, useEffect, useRef } from 'react';

/**
 * Temporary hack that will allow us to use inputs inside of our modal/sheets.
 * This is a workaround for the iOS keyboard bug that causes the modal/sheet not
 * to resize when the keyboard is opened.
 */
export function useModalSheetInputIosKeyboard() {
  const overlayRef = useRef<HTMLDivElement | null>(null);
  const prevWidthRef = useRef(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  const updateViewportHeight = useCallback(() => {
    if (window.visualViewport) {
      const currentWidth = window.innerWidth;
      const isZooming = Math.abs(currentWidth - prevWidthRef.current) > 5; // Threshold for detecting zoom

      if (overlayRef.current && !isZooming) {
        overlayRef.current.style.height = `${window.visualViewport.height}px`;
      }
    }
  }, []);

  useEffect(() => {
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateViewportHeight);
      updateViewportHeight();
    }

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener(
          'resize',
          updateViewportHeight
        );
      }
    };
  }, [updateViewportHeight]);

  return {
    overlayRef,
  };
}
